/**
 * Mapping of fields used in workflow actions (verification + report templates)
 * to default Inquiry field keys, used to ensure correct default when selecting
 * an object for RunReportGeneric and RunVerificationGeneric
 */
export const WORKFLOW_OBJECT_FIELD_KEY_MAPPINGS: Record<string, string> = {
  ['country_code']: 'selected_country_code',
  ['country-code']: 'selected_country_code',
};
